import cityData from "@province-city-china/level/level.min.json";
export default {
  computed: {
    nativePlaceFormat(){
      return (nativePlace) =>{
        if (!nativePlace) return;
        const citys = nativePlace.split(",") ?? [];
        if (!citys.length) return "";
        const res = this.getParentsById(cityData, citys.at(-1).toString())??[]
        res.reverse()
        return res.map((item) => item.n)
          .join("");
      }
    }
  },
  methods: {
    getParentsById(list, code) {
      for (let i in list) {
        if (list[i].c === code) {
          //查询到就返回该数组对象
          return [list[i]];
        }

        if (list[i].d) {
          let node = this.getParentsById(list[i].d, code);
          if (node !== undefined) {
            //查询到把父节点连起来
            return node.concat(list[i]);
          }
        }
      }
    },
  },
};
